var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionTypeClickableImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 108,
    viewBox: "0 0 125 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.8691,
    y: 15.918,
    width: 83.2247,
    height: 64.9945,
    rx: 2.77093,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2059,
    y: 16.2547,
    width: 82.5512,
    height: 64.321,
    rx: 2.4342,
    stroke: "black",
    strokeWidth: 0.673465,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M93.2412 23.8447H40.9285C39.6673 23.8447 38.4576 24.3154 37.5658 25.1532C36.6739 25.991 36.1729 27.1274 36.1729 28.3122V68.5194C36.1729 69.7043 36.6739 70.8406 37.5658 71.6784C38.4576 72.5162 39.6673 72.9869 40.9285 72.9869H93.2412C94.5025 72.9869 95.7121 72.5162 96.604 71.6784C97.4958 70.8406 97.9969 69.7043 97.9969 68.5194V28.3122C97.9969 27.1274 97.4958 25.991 96.604 25.1532C95.7121 24.3154 94.5025 23.8447 93.2412 23.8447ZM75.4073 37.2471C76.1128 37.2471 76.8024 37.4437 77.3889 37.8118C77.9755 38.18 78.4326 38.7033 78.7026 39.3155C78.9726 39.9278 79.0432 40.6015 78.9056 41.2514C78.768 41.9014 78.4282 42.4984 77.9294 42.967C77.4306 43.4356 76.7951 43.7547 76.1032 43.884C75.4113 44.0133 74.6941 43.9469 74.0424 43.6933C73.3907 43.4397 72.8336 43.0102 72.4417 42.4592C72.0498 41.9082 71.8406 41.2604 71.8406 40.5977C71.8406 39.7091 72.2164 38.8569 72.8853 38.2285C73.5542 37.6002 74.4614 37.2471 75.4073 37.2471ZM93.2412 68.5194H40.9285V57.5434L54.7022 44.6017C54.9231 44.394 55.1853 44.2293 55.474 44.1169C55.7626 44.0045 56.0721 43.9466 56.3846 43.9466C56.697 43.9466 57.0065 44.0045 57.2951 44.1169C57.5838 44.2293 57.846 44.394 58.0669 44.6017L78.0824 63.3986C78.5286 63.8177 79.1338 64.0532 79.7647 64.0532C80.3957 64.0532 81.0009 63.8177 81.4471 63.3986C81.8933 62.9795 82.1439 62.411 82.1439 61.8182C82.1439 61.2255 81.8933 60.657 81.4471 60.2379L76.198 55.3097L80.4603 51.3029C80.9062 50.8843 81.5107 50.6492 82.1411 50.6492C82.7715 50.6492 83.3761 50.8843 83.8219 51.3029L93.2412 60.1625V68.5194Z",
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3094 45.7272C84.2751 45.693 84.2497 45.6509 84.2354 45.6046C84.2211 45.5583 84.2183 45.5091 84.2273 45.4615C84.2363 45.4139 84.2568 45.3692 84.2871 45.3313C84.3173 45.2934 84.3564 45.2635 84.4008 45.2442L86.1251 44.5821C86.1793 44.5575 86.2249 44.5172 86.2559 44.4664C86.2869 44.4157 86.302 44.3567 86.2991 44.2973C86.2963 44.2379 86.2757 44.1807 86.2399 44.1331C86.2042 44.0855 86.155 44.0497 86.0988 44.0304L80.1515 42.0884C80.0999 42.0725 80.0449 42.0709 79.9925 42.084C79.94 42.097 79.8921 42.124 79.8539 42.1623C79.8157 42.2005 79.7886 42.2484 79.7756 42.3008C79.7626 42.3533 79.7641 42.4083 79.78 42.4599L81.7209 48.4082C81.7403 48.4645 81.776 48.5137 81.8236 48.5494C81.8712 48.5851 81.9284 48.6057 81.9878 48.6086C82.0473 48.6114 82.1062 48.5964 82.157 48.5653C82.2078 48.5343 82.2481 48.4888 82.2727 48.4346L82.9347 46.7103C82.9541 46.6658 82.984 46.6268 83.0219 46.5966C83.0597 46.5663 83.1044 46.5458 83.1521 46.5368C83.1997 46.5278 83.2488 46.5305 83.2951 46.5448C83.3414 46.5592 83.3835 46.5846 83.4177 46.6189L85.3241 48.5253C85.3798 48.581 85.4554 48.6123 85.5342 48.6123C85.613 48.6123 85.6886 48.581 85.7443 48.5253L86.2158 48.0549C86.2715 47.9992 86.3028 47.9236 86.3028 47.8448C86.3028 47.766 86.2715 47.6904 86.2158 47.6347L84.3094 45.7272Z",
    stroke: "#9BBAC1",
    strokeWidth: 1.18892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15015 57.0604L76.5275 17.7734L8.15015 57.0604Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.618 33.2878L115.947 30.1855L110.618 33.2878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6475 87.5973L54.9766 84.4951",
    stroke: "#E3DFE9",
    strokeWidth: 16.7314,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.181 76.6232C114.012 76.71 114.617 77.4558 114.53 78.2874C114.443 79.1191 113.698 79.7239 112.866 79.6371C112.034 79.5502 111.429 78.8045 111.516 77.9728C111.603 77.1411 112.349 76.5363 113.181 76.6232Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.778901
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5396 94.0595C32.9072 94.2023 33.9017 95.4287 33.7589 96.7963C33.6161 98.164 32.3898 99.1585 31.0221 99.0157C29.6545 98.8729 28.66 97.6465 28.8028 96.2789C28.9456 94.9112 30.1719 93.9167 31.5396 94.0595Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6707 6.05463C61.0383 6.19743 62.0328 7.42379 61.89 8.79144C61.7472 10.1591 60.5209 11.1536 59.1532 11.0108C57.7856 10.868 56.7911 9.64162 56.9339 8.27397C57.0767 6.90632 58.3031 5.91184 59.6707 6.05463Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98518 37.8262C2.61339 37.8262 3.12344 38.3362 3.12344 38.9644C3.12344 39.5926 2.61339 40.1027 1.98518 40.1027C1.35698 40.1027 0.846924 39.5926 0.846924 38.9644C0.846924 38.3362 1.35698 37.8262 1.98518 37.8262Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.535 30.3252C123.164 30.3252 123.674 30.8352 123.674 31.4635C123.674 32.0917 123.164 32.6017 122.535 32.6017C121.907 32.6017 121.397 32.0917 121.397 31.4635C121.397 30.8352 121.907 30.3252 122.535 30.3252Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.379 5.02832L104.678 0.648274",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.911 2.21875L106.291 3.51817",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60132 79.6104L7.74056 75.1859",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03198 76.8564L9.45639 77.9957",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M101.572 99.376L102.463 94.895",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8523 96.7139L104.333 97.605",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeClickableImg);
export default __webpack_public_path__ + "static/media/question_type_clickable_img.fa2719322d0b862c3293b9809f4b29f3.svg";
export { ForwardRef as ReactComponent };